<ol class="stepper" [style.--steps]="stepsCount">
  <div class="line-container" >
    <div class="line-background"></div>

    <div class="line-progress" [style.width]="progressWidth"></div>
  </div>

  <li
    *ngFor="let step of steps; let i = index"
    class="step"
    [class.active]="i <= activeIndex">

    <div class="step-number">
      <ng-container *ngIf="stepTemplate; else defaultStep">
        <ng-container *ngTemplateOutlet="stepTemplate; context: { $implicit: step, index: i }"></ng-container>
      </ng-container>

      <ng-template #defaultStep>
        <i *ngIf="step.icon" [class]="step.icon"></i>
        <span *ngIf="!step.icon">{{ i + 1 }}</span>
      </ng-template>
    </div>

    <span class="step-label">{{ step.label }}</span>
  </li>
</ol>
